import './ui.css';

/** Pantalla completa de carga (usada mientras se valida la sesión). */
export default function LoadingScreen({ label = 'Cargando…' }) {
  return (
    <div className="loading-screen">
      <span className="loading-screen__spinner" aria-hidden="true" />
      <p>{label}</p>
    </div>
  );
}
